import { render } from "./Expiring.vue?vue&type=template&id=60c3de84"
import script from "./Expiring.vue?vue&type=script&lang=js"
export * from "./Expiring.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__